export const CREATE_GRID_GAME_COMPLETED = "project/gridGame/createGridGameCompleted";
export const GET_GRID_GAME_BOARD_COMPLETED = "project/gridGame/getGridGameBoardCompleted";
export const VALIDATE_GRID_SLOT_COMPLETED = "project/gridGame/validateGridSlotCompleted";
export const AUTOCOMPLETE_PILOTS_COMPLETED = "project/gridGame/autocompletePilotsCompleted";
